import React, { Component } from "react";
import { DynamicFormFieldProps } from "../DynamicForm";
import { DynamicFormField } from "../../laco-common/base/form-validation/dynamic";
import { ISection } from "../../laco-common";
import { WithOptional } from "../../laco-common/helpers/extendedTypes";
import ItemFormInput from "./ItemForm";
import "./FormSection.scss";
import { generateDummyId } from "../../models/cms";

const getFields = (
	data: ISection
): Record<keyof Partial<ISection>, DynamicFormField & WithOptional<Partial<ISection>, "id">> => {
	return {
		name: { label: "Section Name", order: 10, value: data?.name, placeholder: "", optional: true },
		description: {
			label: "Description",
			optional: true,
			order: 20,
			value: data?.description,
			placeholder: "",
		},
		order: { label: "Order", fieldType: "number", isInteger: true, value: data?.order, order: 38 },
		noBorder: { label: "No Border", fieldType: "boolean", value: data?.noBorder, order: 39, optional: true },
		active: { label: "Active", fieldType: "boolean", value: data?.active, order: 40 },
		fields: {
			label: "Section Fields",
			fieldType: "list",
			listType: "formField",
			optional: true,
			value: data?.fields,
			order: 100,
		},
	} as any; // simba
};

export default class FormSectionInput extends Component<DynamicFormFieldProps> {
	componentDidMount() {
		console.log("FormFieldInput.componentDidMount(): props", this.props);
	}

	render() {
		return (
			<ItemFormInput
				{...this.props}
				itemName="Form Section"
				nameField="name"
				viewItemSelector="[id^='laco-form-section-container-']"
				itemClassName="formsection-item"
				containerClassName="formsection-container"
				getFields={getFields}
				createNew={(i): ISection => {
					return {
						name: `Section ${i + 2}`,
						order: (i + 1) * 10 + 10,
						id: generateDummyId(),
						active: true,
						fields: [],
					};
				}}
			/>
		);
	}
}
